<template>
  <form @submit.prevent="submit" class="form" method="post">
    <FormInput :name="$t('meta.name')" v-model="project.name" />

    <FormSimpleSelect
      v-if="locations"
      :name="$t('meta.location')"
      :options="locations"
      v-model="project.location_uuid"
    />
    <LoadingSpinner v-else />

    <FormInput :name="$t('meta.slocApiKeyEnvOverwrite')" v-model="project.sloc_api_key_env_overwrite" />

    <FormInput :name="$t('meta.lctApiKeyEnvOverwrite')" v-model="project.lct_api_key_env_overwrite" placeholder="" />

    <div>
      <input type="submit" :value="$t('meta.save')" class="button button-green button-100" />
    </div>
  </form>
</template>

<script>
import FormInput from '@/components/Form/Input'
import FormSimpleSelect from '@/components/Form/SimpleSelect'
import LoadingSpinner from '@/components/LoadingSpinner'

import locationsApi from '@/api/locations'

export default {
  props: {
    companyUuid: String,
    initialProject: Object,
  },
  components: {
    LoadingSpinner,
    FormInput,
    FormSimpleSelect,
  },
  data: function () {
    return {
      project: this.initialProject || {
        name: null,
        location_uuid: null,
        sloc_api_key_env_overwrite: null,
        lct_api_key_env_overwrite: null,
      },
      locations: null,
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.project)
    },
  },
  computed: {
    selectedLocation() {
      return this.locations?.find(location => location.uuid === this.project.location_uuid)
    },
  },
  async mounted() {
    this.locations = await locationsApi.getAllForCompany(this.companyUuid)
  },
}
</script>
